import { createTheme, MantineColorScheme, MantineThemeOverride } from '@mantine/core';
import {
	darkColors,
	errorColorScale,
	generateColorVariables,
	infoColorScale,
	lightColors,
	neutralColorScale,
	primaryColorScale,
	successColorScale,
	warningColorScale,
} from './colors';
import { componentConfig } from './componentConfig';

// Main theme configuration
export const baseTheme: MantineThemeOverride = createTheme({
	// Font configuration
	fontFamily: '"Albert Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
	fontFamilyMonospace: 'Monaco, Courier, monospace',
	headings: {
		fontFamily: '"Canela", Georgia, serif',
		fontWeight: '400',
	},

	// Color configuration
	primaryColor: 'primary',
	colors: {
		primary: primaryColorScale,
		neutral: neutralColorScale,
		info: infoColorScale,
		success: successColorScale,
		error: errorColorScale,
		warning: warningColorScale,
	},

	// Other configuration
	other: {
		// Add semantic colors for easy access
		lightColors,
		darkColors,
		// Add additional font families for specific use cases
		fonts: {
			body: '"Albert Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
			heading: '"Canela", Georgia, serif',
			headingText: '"Canela Text", Georgia, serif',
			mono: 'Monaco, Courier, monospace',
		},
	},
	...componentConfig.desktop,
});

// Helper function to apply theme CSS variables
export const applyThemeVariables = (colorScheme: MantineColorScheme) => {
	const root = document.documentElement;

	// Resolve 'auto' to actual scheme
	const resolvedScheme =
		colorScheme === 'auto'
			? window.matchMedia('(prefers-color-scheme: dark)').matches
				? 'dark'
				: 'light'
			: colorScheme;

	// Apply color variables
	const colorVariables = generateColorVariables(resolvedScheme);
	Object.entries(colorVariables).forEach(([key, value]) => {
		root.style.setProperty(key, value);
	});

	// Set color scheme indicator
	root.setAttribute('data-mantine-color-scheme', colorScheme);
};
